import React from 'react';
import HeroSection from '../components/homepage/HeroSection';
import OurPicksSection from '../components/homepage/OurPicksSection';
import ServicesSection from '../components/homepage/ServicesSection';
import AboutCollectionsRow from '../components/homepage/AboutCollectionsRow';
import WhyChooseUsSection from '../components/homepage/WhyChooseUsSection';
import CTABand from '../components/homepage/CTABand';
import './HomePage.css';

const HomePage: React.FC = () => {
  return (
    <main className="home-page">
      <HeroSection />
      <OurPicksSection />
      <ServicesSection />
      <AboutCollectionsRow />
      <WhyChooseUsSection />
      <CTABand />
    </main>
  );
};

export default HomePage;
